'use client';
import { useProfileStore } from '@ninjacart/nc-nk-store';
import { ChevronLeft } from '@tamagui/lucide-icons';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import { useNavigation } from '@ninjacart/nc-nk-web-deps';
import { XStack, useTheme } from 'tamagui';
import { Platform } from 'react-native';
import { useRef, useState } from 'react';
import {
  useQueuedEventStore,
  addEventParam,
  INinjaEvent,
  KissanEventType,
} from '@ninjacart/nc-events-sdk-v2';

export const NavHeaderComponent = ({ page }: { page?: string }) => {
  const { back } = useRouter();
  const navigation = useNavigation();
  const userProfile = useProfileStore((state) => state.userProfile);
  const theme = useTheme();
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const handleBackPressEvent = () => {
    const backPressEvent :INinjaEvent = {
      name: KissanEventType.BACK_PRESS,
      screenDetails: { screen: 'nav header page' },
      eventParams: [addEventParam('currentPage', page)],
    };
    enqueue(backPressEvent);
  };

  const onGoBack = () => {

    
    if(Platform.OS === 'web'){
      handleBackPressEvent();
      back();
      return;
    }

    if (navigation) {
      if (navigation?.canGoBack()) {
        handleBackPressEvent();
        back();
        return;
      }
      navigation?.reset({
        index: 0,
        routes: [{ name: '(tabs)' }],
      });
    } else {
      handleBackPressEvent();
      back();
      return;
    }
  };

  return (
    <XStack
      flexDirection={'row'}
      borderRadius={16}
      borderWidth={1}
      borderColor={'$grey'}
      background={theme['background']?.val}
      padding={6}
      marginRight={5}
      alignItems={'center'}
      onPress={onGoBack}
    >
      <ChevronLeft color={'$weatherTextColor'} size="$2"  />
    </XStack>
  );
};
